import { useTheme as useNextTheme } from 'next-themes'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'

import { nextThemeToUserThemeMap } from '~common/ThemeProvider'
import { useUpdateUserMutation } from '~generated/hooks'
import { Theme } from '~generated/types'
import { AUTH_DATA_KEYS } from '~lib/constants'
import useCookie from '~lib/hooks/useCookie'
import { Navigation } from '~lib/routes'

export default function useTheme() {
  const { theme, setTheme } = useNextTheme()

  const toggleTheme = useCallback(() => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }, [setTheme, theme])

  const cookie = useCookie()
  const userId = cookie[AUTH_DATA_KEYS.USER_ID]
  const router = useRouter()
  const isPublicRoute = Navigation.isPublicRoute(router)

  const [updateUserMutation] = useUpdateUserMutation()

  useIsomorphicLayoutEffect(() => {
    if (userId && !isPublicRoute && nextThemeToUserThemeMap[theme]) {
      updateUserMutation({
        variables: {
          input: {
            id: userId,
            theme: nextThemeToUserThemeMap[theme],
          },
        },
      })
    }
  }, [theme, isPublicRoute])

  return [nextThemeToUserThemeMap[theme] as Theme, toggleTheme] as const
}
